import { ColumnConfig } from './column-config';
import { ComponentConfig } from './component.config';
import { StoreColumnExtractor } from './extractors';
import { TabConfig } from './tab-config';
import { TabDisplayConfig } from './tab-display-config';

/*******************************************
 * HERE BE DRAGONS - NO DISPLAY COMPONENT SPECIFIC LOGIC ALLOWED
 * Under no circumstances DO NOT change the code below if it looks like it doesn't do what you need it to do.
 * Consult the team if there's functionality missing !!!
 *******************************************/
export interface ComponentVisibilityMapping {
	[key: string]: ComponentVisibility;
}

export class ComponentVisibility {
	public static create(options: ComponentVisibilityOptions): ComponentVisibility {
		return new ComponentVisibility(options.componentId, options.visible, options.tabs, options.portfolioDataExtractor, options.hideOnError, options.idMapper);
	}
	constructor(
		public readonly componentId: string,
		public readonly visible: VisibleConfigOptions,
		public readonly tabs: TabConfigMapping,
		public readonly portfolioDataExtractor: ColumnConfig<StoreColumnExtractor>[] = ComponentConfig.DEFAULT_PORTFOLIO_COLUMNS,
		public readonly hideOnError: boolean = false,
		public readonly idMapper: { [viewCategory: string]: IdMapperConfig }
	) { }
}

export interface ComponentVisibilityOptions {
	componentId: string;
	visible: VisibleConfigOptions;
	tabs: TabConfigMapping;
	portfolioDataExtractor?: ColumnConfig<StoreColumnExtractor>[];
	hideOnError?: boolean;
	idMapper?: { [viewCategory: string]: IdMapperConfig };
}

export interface VisibleConfigOptions {
	[key: string]: boolean;
}

export interface TabConfigMapping {
	[key: string]: TabVisibilityConfigOptions;
}

export interface TabVisibilityConfigOptions {
	[key: string]: TabVisibleConfigOptions;
}

export interface TabVisibleConfigOptions {
	config: TabConfig;
	rule: TabDisplayConfig;
}
export interface IdMapperConfig {
	ids: string[];
	includeDefaultIds: boolean;
}
